import axios from 'common/axios';
import Settings from 'common/config/settings';
import { ChatEnablement, ZendeskUserData } from 'models';

const API = `${Settings.api['authz-api']}/v1/authorize`;

export enum AUTHZ {
  GET_ZENDESK_TOKEN = 'authz.get-zendesk-token',
  GET_CHAT_ENABLEMENT = 'authz.get-chat-enablement',
}

export const getZendeskToken = (): Promise<ZendeskUserData> => axios.get(`${API}/zendesk`);
export const getChatEnablement = (): Promise<ChatEnablement> => axios.get(`${API}/channel-support-enablement`);
